import React from 'react'

// eslint-disable-next-line no-unused-vars
import { IPaginateContext } from '../interfaces/paginate'

export const PaginateContext = React.createContext<IPaginateContext>({
  page: 0,
  setPage: () => {},
  index: 0,
  endIndex: 0,
  totalItems: 0,
  isFirstPage: () => true,
  isLastPage: () => true,
  nextPage: () => {},
  previousPage: () => {}
})
